import React, {Component} from 'react';
import { connect } from 'react-redux';
import {Control, Form, Errors} from 'react-redux-form';
import RegistrationAction from "../../actions/RegistrationAction";
import preloader from '../../image/preloader.gif';

class Owner extends Component {

  submit(data) {
    this.props.sendOwnerData(data);
  }

  render() {
    let {signOwnerForm, requestStatus} = this.props;
    return (
      <div className="row  signup-box">
        <div className="col-md-8 col-md-offset-2">
          <Form model="forms.signOwnerForm" className="sing-box"  onSubmit={(data) => this.submit(data)} >
            <h1 className="text-center">Start Claiming...</h1>
            <h2 className="text-center text-finish" style={{marginBottom: '15px'}}>
              Your business’s page is now in the approval process to be added to Rifird. <br/>
              Get Started unlocking more benefits by creating an account and claiming this business.
            </h2>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label htmlFor="owner_first_name">Fist name</label>
                  <Control.text type="text" model="forms.signOwnerForm.first_name"
                                className="form-control"
                                validators={{
                                  required: (val) => val && val.length
                                }}
                                id="owner_first_name" placeholder="Fist name"/>
                  <div className="error-box">
                    <Errors
                      className="error"
                      model="forms.signOwnerForm.first_name"
                      show={(field) => field.submitFailed && !field.valid}
                      messages={{
                        required: 'Fist name cannot be blank'
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label htmlFor="owner_last_name">Last name</label>
                  <Control.text type="text" model="forms.signOwnerForm.last_name"
                                className="form-control"
                                validators={{
                                  required: (val) => val && val.length
                                }}
                                id="owner_last_name" placeholder="Last name"/>
                  <div className="error-box">
                    <Errors
                      className="error"
                      model="forms.signOwnerForm.last_name"
                      show={(field) => field.submitFailed && !field.valid}
                      messages={{
                        required: 'Last name cannot be blank'
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label htmlFor="password">Password</label>
                  <Control.text type="password" model="forms.signOwnerForm.password"
                                className="form-control"
                                validators={{
                                  required: (val) => val && val.length,
                                  min: (val) => val.length === 0 || val.length >= 8
                                }}
                                id="password" placeholder="Password"/>
                  <div className="error-box">
                    <Errors
                      className="error"
                      model="forms.signOwnerForm.password"
                      show={(field) => field.submitFailed && !field.valid}
                      messages={{
                        required: 'Password cannot be blank',
                        min: 'Password must be min 8 characters'
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label htmlFor="confirm_password">Confirm password</label>
                  <Control.text type="password" model="forms.signOwnerForm.confirm_password"
                                className="form-control"
                                validators={{
                                  required: (val) => val && val.length,
                                  checkConfirmPassword: (val) => val.length === 0 || val === signOwnerForm.password
                                }}
                                id="confirm_password" placeholder="Confirm password"/>
                  <div className="error-box">
                    <Errors
                      className="error"
                      model="forms.signOwnerForm.confirm_password"
                      show={(field) => field.submitFailed && !field.valid}
                      messages={{
                        required: 'Confirm password cannot be blank',
                        checkConfirmPassword: 'Confirm password and password don\'t match'
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <button disabled={requestStatus} type="submit" className="btn btn-action">Done</button>
            <img src={preloader} style={{top: '-16px'}} className={requestStatus ? 'loader-button' : 'loader-button none'} alt="loading..." />
          </Form>
        </div>
      </div>
    )
  }
}

export default connect(
  state => ({
    currentStep: state.currentStep,
    requestStatus: state.requestStatus,
    signOwnerForm: state.forms.signOwnerForm
  }),
  dispatch => ({
    sendOwnerData: (data) => {
      dispatch(RegistrationAction.sendOwnerData(data));
    }
  })
)(Owner);


/** WEBPACK FOOTER **
 ** ./src/components/Sign/owner.js
 **/